__turbopack_context__.v({
  "className": "geist_mono_36530d6f-module__lamg2q__className",
});
